import { render, staticRenderFns } from "./OrdemNiveisExpansao.vue?vue&type=template&id=3797791a&scoped=true"
import script from "./OrdemNiveisExpansao.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdemNiveisExpansao.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrdemNiveisExpansao.vue?vue&type=style&index=0&id=3797791a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3797791a",
  null
  
)

export default component.exports